import { render, staticRenderFns } from "./testSysUser.vue?vue&type=template&id=1672936a&scoped=true"
import script from "./testSysUser.vue?vue&type=script&lang=js"
export * from "./testSysUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1672936a",
  null
  
)

export default component.exports